

const Link = function (props) {
    //console.log(props.data)
    let img = props.data.ModMobileImage ? <img src={props.data.ModMobileImage_Url } title={props.data.Title}/>: null
    return (
        <div className="drawerLink">
            <a href={props.data.ModLinksLink.NavigateUrl} title="" >
                {img}
                {props.data.Title}
            </a>
        </div>
    );
}
export default Link;